module.exports = __webpack_public_path__ + "static/media/dealersMetaImage.82ff1efd.png";